import { CircularProgress, TextField } from "@mui/material";

import { LinearProgress } from "@mui/material";

import { Box } from "@mui/material";

import { Button } from "@mui/material";

import { Paper, Typography } from "@mui/material";

import FolderOpenIcon from '@mui/icons-material/FolderOpen';
interface SubmitOptionsProps {
  mapSourceDataToEconomic: (sourceData: any[]) => void;
  sourceData: any[];
  economicData: any[];
  isSubmitting: boolean;
  handleSubmitMapping: () => void;
  handleStopSubmit: () => void;
  submissionReport: any;
  currentBatch: number;
  totalBatches: number;
  submitProgress: number;
  setShowReport: (show: boolean) => void;
  skipLines?: number;
  handleSkipLinesChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAutoMapFirstRow?: () => void;
  submissionId?: string;
}

const SubmitOptions = ({
  mapSourceDataToEconomic,
  sourceData,
  economicData,
  isSubmitting,
  handleSubmitMapping,
  handleStopSubmit,
  submissionReport,
  currentBatch,
  totalBatches,
  submitProgress,
  setShowReport,
  skipLines,
  handleSkipLinesChange,
  onAutoMapFirstRow,
  submissionId,
}: SubmitOptionsProps) => {

    const handleSubmit = () => {
        mapSourceDataToEconomic(sourceData);
        setTimeout(() => {
          handleSubmitMapping();
        }, 1000);
    }
  return (
    <Paper sx={{ 
        p: 2, 
        mb: 2, 
        position: 'sticky', 
        top: 178,
        zIndex: 1000, 
        backgroundColor: 'white',
        // boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <Typography variant="h6" gutterBottom>
          Submit Options
        </Typography>
        {submissionId && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Submission ID: {submissionId}
          </Typography>
        )}
        {/* <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4, mb: 1 }}>
          <FormControlLabel
            control={
              <Switch
                checked={updateExistingCustomer}
                onChange={(e) => setUpdateExistingCustomer(e.target.checked)}
              />
            }
            label="Update existing customer"
          />
          {updateExistingCustomer && (
          <Box sx={{ mb: 2 , width: '200px'}}>
            <FormControl fullWidth size="small">
              <InputLabel>Key</InputLabel>
              <Select
                value={updateKey}
                label="Key"
                onChange={(e) => setUpdateKey(e.target.value)}
              >
                {dineroColumns.map((column) => (
                  <MenuItem key={column.id} value={column.id}>
                    {column.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        </Box> */}
        
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
        <TextField
            type="number"
            label="Skip Lines"
            value={skipLines}
            onChange={handleSkipLinesChange}
            inputProps={{ min: 0 }}
            size="small"
            sx={{ width: 120 }}
          />
          <Button
            variant="outlined"
            color="primary"
            onClick={onAutoMapFirstRow}
            disabled={sourceData.length === 0 || isSubmitting}
          >
            Match columns
          </Button>
          <Button
            variant="contained"
            onClick={() => mapSourceDataToEconomic(sourceData)}
            disabled={sourceData.length === 0 || isSubmitting}
          >
            Update data
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSubmit}
            disabled={economicData.length === 0 || isSubmitting}
          >
            Submit Data to E-conomic
          </Button>
          {isSubmitting && (
            <Button
              variant="contained"
              color="error"
              onClick={handleStopSubmit}
            >
              Stop
            </Button>
          )}
          {submissionReport && (
            <Button
              variant="outlined"
              onClick={() => setShowReport(true)}   
              startIcon={<FolderOpenIcon />}
            >
              View Report
            </Button>
          )}
          {isSubmitting && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2">
                Processing batch {currentBatch} of {totalBatches} (
                {submitProgress}%)
              </Typography>
              <CircularProgress size={20} />
              <LinearProgress variant="determinate" value={submitProgress} />
            </Box>
          )}
        </Box>
      </Paper>
  );
};

export default SubmitOptions;
